import {
    Button, PlusIcon
} from "melco-ui";

import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";

type UserWizardsButtonProps = {
    referencesDrawer: DrawerType;

};

export const UserWizardsButton: React.FC<
    UserWizardsButtonProps
> = ({ referencesDrawer }) => {

    return (

        <Button
            key="color-collection-duplicate"
            type="primary"
            onClick={async () => {
                referencesDrawer.openDrawer();
            }}

        >
            {/* {t('users.wizards.button')} */}
            <PlusIcon /> Add
        </Button>


    );
};
